export var IdFacebookStatus;
(function (IdFacebookStatus) {
    IdFacebookStatus["connected"] = "connected";
    IdFacebookStatus["notAuthorized"] = "not_authorized";
})(IdFacebookStatus || (IdFacebookStatus = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/facebook/IdFacebookStatus.ts
// module id = 2751
// module chunks = 3